<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wine.create")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineWineForm :APIbaseURL="APIbaseURL" :wine="this.wine" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineWineForm } from 'aveine-wine';
import { Wine } from 'aveine-toolbox';
export default {
  data () {
    return {
      wine: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineWineForm
  },
  async created() {
    this.wine = await Wine.new();
    this.wine.$isNew = true;
    this.dataLoaded = true;
  },
}
</script>
